import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { debounce } from '@owc-utils/Events';

const DEFAULT_DEBOUNCE_TIME = 1000;
let isListenerInitialized = false;
let isLastObserverCalled = false; // ignore the first call

const mixin: ThisTypedComponentOptionsWithRecordProps<Vue, {}, {}, {}, {}, {}, {}, {}> = {
  mounted: function() {
    if (!isListenerInitialized) {
      isListenerInitialized = true;
      const root = document.querySelector('.root') as HTMLElement;

      if (root) {
        const resizeObserver = new ResizeObserver(
          debounce(
            DEFAULT_DEBOUNCE_TIME,
            () => {
              if (isLastObserverCalled) {
                document.dispatchEvent(
                  new CustomEvent('page-has-rendered', {
                    bubbles: true,
                    composed: true,
                    detail: {
                      element: root,
                    },
                  }),
                );
                resizeObserver.unobserve(root);
              }

              isLastObserverCalled = true;
            },
            false,
          ),
        );
        resizeObserver.observe(root);
      }
    }
  },
};

export default mixin;
